import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SavingAgreementNotes } from "@app/models/saving-agreement-notes";
import { SavingAgreementNotesService } from "@app/services/saving-agreement-notes.service";

@Component({
    selector: "app-saving-agreement-note-node",
    templateUrl: "./saving-agreement-note-node.component.html",
    styleUrls: ["./saving-agreement-note-node.component.css"],
    standalone: false
})
export class SavingAgreementNoteNodeComponent implements OnInit {
  @Input() level: number;
  @Input() savingAgreementNotes: Array<SavingAgreementNotes>;
  @Input() selectedSavingAgreementNotes: Array<SavingAgreementNotes>;
  @Output() onAddSavingAgreementNote = new EventEmitter<SavingAgreementNotes>();
  @Output() onDeleteSavingAgreementNote = new EventEmitter<SavingAgreementNotes>();

  constructor(private savingAgreementNotesService: SavingAgreementNotesService) {}

  ngOnInit(): void {}

  changeNoteStatus(item, value) {
    if (value.target.checked) {
      this.addSavingAgreementNote(item);
    } else {
      this.deleteSavingAgreementNote(item);
    }
  }

  addSavingAgreementNote(item) {
    this.onAddSavingAgreementNote.emit(item);
  }

  deleteSavingAgreementNote(item) {
    this.onDeleteSavingAgreementNote.emit(item);
  }

  isSelectedSavingAgreementNote(item: SavingAgreementNotes): boolean {
    if (!this.selectedSavingAgreementNotes || !item) {
      return false;
    }
    return this.selectedSavingAgreementNotes.some((p) => p && p.id === item.id);
  }

  isIndeterminate(item: SavingAgreementNotes): boolean {
    if (!item || !item.subSavingAgreementNotes || item.subSavingAgreementNotes.length === 0) {
      return false;
    }
    if (this.isSelectedSavingAgreementNote(item)) {
      return false;
    }
    return this.hasSelectedDescendant(item);
  }

  isExpanded(item: SavingAgreementNotes): boolean {
    if (this.isSelectedSavingAgreementNote(item)) {
      return true;
    }
    return this.hasSelectedDescendant(item);
  }

  private hasSelectedDescendant(item: SavingAgreementNotes): boolean {
    if (!item || !item.subSavingAgreementNotes || item.subSavingAgreementNotes.length === 0) {
      return false;
    }
    return item.subSavingAgreementNotes.some(
      (child) => this.isSelectedSavingAgreementNote(child) || this.hasSelectedDescendant(child)
    );
  }

}
